export default "__VITE_ASSET__JO5RxFT___"